import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/layout/Layout';
import { Calendar, MapPin, Ticket } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaidEventsPage() {
  const [events, setEvents] = useState(null);
  useEffect(() => { axios.get(`${API}/api/paid-events`).then(r => setEvents(r.data)).catch(() => setEvents([])); }, []);

  return (
    <Layout title="Events">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0A0F1C] mb-2">Upcoming Events</h1>
        <p className="text-[#475569] mb-10">Workshops, summits, and live intensives to grow your business.</p>
        {events === null && <div className="text-center text-[#94A3B8] py-12">Loading…</div>}
        {events && events.length === 0 && <div className="text-center text-[#94A3B8] py-12" data-testid="events-empty">No upcoming events right now — check back soon.</div>}
        <div className="grid md:grid-cols-2 gap-6">
          {(events || []).map(ev => {
            const from = ev.ticket_tiers.length ? Math.min(...ev.ticket_tiers.map(t => t.price)) : 0;
            return (
              <Link to={`/tickets/${ev.slug}`} key={ev.event_id} className="block bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden hover:shadow-lg transition-shadow" data-testid={`event-card-${ev.slug}`}>
                {ev.image_url ? <img src={ev.image_url} alt={ev.title} className="w-full h-44 object-cover" /> : <div className="w-full h-44 bg-gradient-to-br from-[#0F172A] to-[#F97316] flex items-center justify-center"><Ticket size={48} className="text-white/40" /></div>}
                <div className="p-5">
                  <h2 className="text-lg font-bold text-[#0A0F1C] mb-2">{ev.title}</h2>
                  <div className="space-y-1 text-sm text-[#475569]">
                    {ev.starts_at && <div className="flex items-center gap-2"><Calendar size={14} className="text-[#F97316]" />{new Date(ev.starts_at).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}</div>}
                    {(ev.venue || ev.location) && <div className="flex items-center gap-2"><MapPin size={14} className="text-[#F97316]" />{[ev.venue, ev.location].filter(Boolean).join(', ')}</div>}
                  </div>
                  <div className="mt-4 inline-block text-sm font-bold text-[#F97316]">From ${from} →</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
